export default __webpack_public_path__ + "static/fs2-40dcbfa900dcf135c9d8c9f3b0b64418.png";